
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import { t } from "i18next";
import "./gallery.css";

function Gallery({ gallery, showAll }) {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [flattenedImages, setFlattenedImages] = useState([]);

  // Flatten images and prepare slides
  useEffect(() => {
    if (!gallery) return;
    const imagesArray = gallery.flatMap((item) =>
      item.images.map((img) => ({
        src: img.url,
        description: item.title,
      }))
    );
    setFlattenedImages(imagesArray);
  }, [gallery]);

  const imagesToDisplay = showAll ? flattenedImages : flattenedImages.slice(0, 6);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
    <div className="container">
      <div className="text-center">
        <h2 className="p-t30 text-black">{t("gallery")}</h2>
        <div className="mt-separator-outer">
          <div className="mt-separator site-bg-primary mb-5" />
        </div>
      </div>

      {flattenedImages.length > 0 ? (
        <Slider {...sliderSettings}>
          {imagesToDisplay.map((img, index) => (
            <div
              key={index}
              className="image-container"
              onClick={() => {
                setPhotoIndex(index);
                setIsOpen(true);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setPhotoIndex(index);
                  setIsOpen(true);
                }
              }}
              role="button"
              tabIndex={0}
            >
              <img
                className="card-img-top"
                src={img.src}
                alt={img.description}
                loading="lazy"
              />
            </div>
          ))}
        </Slider>
      ) : (
        <div className="text-center py-4">Loading images...</div>
      )}

      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          index={photoIndex}
          slides={flattenedImages}
          plugins={[Zoom, Captions, Thumbnails]}
          carousel={{ finite: false }}
          animation={{ fade: 300 }}
          captions={{ showToggle: true }}
          zoom={{ maxZoomPixelRatio: 2 }}
          thumbnails={{ position: "bottom", width: 100, height: 60, border: 2 }}
        />
      )}
    </div>
  );
}

export default Gallery;

